import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Checkbox} from '@components/common/base/checkbox'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {SelectWithUsers} from '@components/common/base/select-with-dropdown/select-with-users'
import {menuItemHeight} from './constants'
import {getRemoveAssignedOptions} from './helpers/get-remove-assigned-options'
import {useMovementStore} from './movement-store'

interface Props {
  board: Hub
  destBoard?: Hub
}

export const TwAction = tw.div`
  flex
  items-center
  h-40
`

export const RemoveAssignedActions = observer(({board, destBoard}: Props) => {
  const [state, store] = useMovementStore()

  const lang = Lang.msg.movementTemplates
  const removeAssignedOptions = getRemoveAssignedOptions()
  const selected = removeAssignedOptions.find(
    i => i.key === state.removeAssignedItem
  )

  return (
    <>
      <TwAction>
        <Checkbox
          value={!!state.removeAssigned}
          text={lang.createRemoveAssigned}
          onChange={store.removeAssignedChanged}
        />

        <div className="max-w-230 min-w-230 ml-auto">
          <SelectWithDropdown
            options={removeAssignedOptions}
            value={selected?.text || ''}
            size={menuItemHeight}
            disabled={!state.removeAssigned}
            width={'min-w-230 max-w-230'}
            onChange={store.removeAssignedItemChanged}
          />
        </div>
      </TwAction>

      {state.removeAssigned && state.removeAssignedItem === 'specific-users' && (
        <TwAction>
          <div className="max-w-230 min-w-230 ml-auto">
            <SelectWithUsers
              board={board}
              onChange={store.removeAssignedUsersChanged}
              selectedUserIds={state.removeAssignedUsers}
              placeholder={lang.placeholderAssigned}
            />
          </div>
        </TwAction>
      )}

      <TwAction>
        <Checkbox
          value={!!state.addNewAssigned}
          text={lang.createAddNewAssigned}
          onChange={store.addNewAssignedChanged}
        />

        <div className="max-w-230 min-w-230 ml-auto">
          {destBoard && (
            <SelectWithUsers
              board={destBoard}
              onChange={store.addNewAssignedUsersChanged}
              selectedUserIds={state.addNewAssignedUsers}
              disabled={!state.addNewAssigned || !destBoard}
              placeholder={lang.placeholderAssigned}
            />
          )}
        </div>
      </TwAction>
    </>
  )
})
